"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchSignOutSaga = exports.stytchSignOut = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const typed_redux_saga_1 = require("typed-redux-saga");
const api_1 = require("../../api");
const storageManagement_1 = require("../tokens-storage/storageManagement");
const adaptStorage_1 = require("../tokens-storage/adaptStorage");
const stytchClearStoreSaga_1 = require("./stytchClearStoreSaga");
const stytchLoadingSlot_1 = require("./stytchLoadingSlot");
const stytchSetAuthenticatedSaga_1 = require("./stytchSetAuthenticatedSaga");
const stytchWarning_1 = require("./stytchWarning");
exports.stytchSignOut = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/SIGN_OUT');
function* stytchSignOutSaga() {
    yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchClearWarnings)());
    yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
        slot: stytchLoadingSlot_1.StytchLoadingSlot.SIGN_OUT,
        loading: true,
    }));
    try {
        const userServiceAddress = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'userServiceAddress');
        const storage = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'storage');
        const adaptedStorage = (0, adaptStorage_1.adaptStorage)(storage);
        const accessToken = yield* (0, typed_redux_saga_1.call)(storageManagement_1.getAccessToken, adaptedStorage);
        if (accessToken) {
            yield* (0, typed_redux_saga_1.call)(api_1.stytchFetchSignOut, accessToken, userServiceAddress);
        }
        yield* (0, typed_redux_saga_1.call)(storageManagement_1.removeAccessToken, adaptedStorage);
        yield* (0, typed_redux_saga_1.call)(storageManagement_1.removeOldAccessToken, adaptedStorage);
        yield* (0, typed_redux_saga_1.put)((0, stytchSetAuthenticatedSaga_1.stytchSetAuthenticated)(false));
        yield* (0, typed_redux_saga_1.put)((0, stytchClearStoreSaga_1.stytchClearStore)());
    }
    catch (e) {
        const { message: errorMessage } = e;
        if (errorMessage) {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.SIGN_OUT,
                isValid: false,
                message: errorMessage,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.SIGN_OUT,
                isValid: false,
                message: stytchWarning_1.StytchWarningMessage.SIGN_OUT,
            }));
        }
    }
    finally {
        yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
            slot: stytchLoadingSlot_1.StytchLoadingSlot.SIGN_OUT,
            loading: false,
        }));
    }
}
exports.stytchSignOutSaga = stytchSignOutSaga;
